import { Injectable } from '@angular/core';
import { AppState, FilterState } from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { setIsMobileFilterOpen } from '@immosky/object-search-layout';
import { selectFilterState, updateFilter } from '@immosky/object-search-filter';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private currentFilterState!: FilterState;
  private filterStateSnapshot!: FilterState;

  constructor(private store: Store<AppState>) {
    this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.currentFilterState = filterState;
      });
  }

  openMobileFilters() {
    this.filterStateSnapshot = this.currentFilterState;
    this.store.dispatch(
      setIsMobileFilterOpen({
        isOpen: true,
      })
    );
  }

  closeMobileFilters() {
    this.store.dispatch(
      setIsMobileFilterOpen({
        isOpen: false,
      })
    );
  }

  closeMobileFiltersAndIgnoreFilterChanges() {
    const filtersHaveChanged =
      this.filterStateSnapshot &&
      this.filterStateSnapshot !== this.currentFilterState;

    if (filtersHaveChanged) {
      this.store.dispatch(
        updateFilter({
          contractType: this.filterStateSnapshot.contractType.filter,
          mainCategory: this.filterStateSnapshot.category.main.filter,
          subcategory: this.filterStateSnapshot.category.sub.filter,
          price: this.filterStateSnapshot.price.filter,
          livingSpace: this.filterStateSnapshot.livingSpace.filter,
          usageSpace: this.filterStateSnapshot.usageSpace.filter,
          propertySpace: this.filterStateSnapshot.propertySpace.filter,
          roomCount: this.filterStateSnapshot.roomCount.filter,
          countries: this.filterStateSnapshot.countries,
          regions: this.filterStateSnapshot.region.regions,
          radius: this.filterStateSnapshot.radius.filter,
        })
      );
    }

    this.store.dispatch(
      setIsMobileFilterOpen({
        isOpen: false,
      })
    );
  }
}
